import { useEffect, useState } from 'react';
import {
  VALID_THEMES,
  VALID_FONT_SIZES,
  readStoredTheme,
  readStoredFontSize,
  setTheme as applyAndPersistTheme,
  setFontSize as applyAndPersistFontSize,
  type Theme,
  type FontSize,
} from '../../lib/theme.js';

export function UserSettingsSubscreen() {
  const [theme, setThemeState] = useState<Theme>(() => readStoredTheme());
  const [fontSize, setFontSizeState] = useState<FontSize>(() => readStoredFontSize());

  useEffect(() => {
    applyAndPersistTheme(theme);
  }, [theme]);

  useEffect(() => {
    applyAndPersistFontSize(fontSize);
  }, [fontSize]);

  return (
    <div data-testid="user-settings" className="p-4 space-y-6">
      <div>
        <p className="text-sm font-semibold mb-2">Тема интерфейса</p>
        <div className="flex gap-2">
          {VALID_THEMES.map((t) => (
            <button
              key={t}
              type="button"
              aria-pressed={theme === t}
              onClick={() => setThemeState(t)}
              data-testid={`theme-btn-${t}`}
              className={`px-3 py-1 rounded border text-sm ${theme === t ? 'bg-mnp-stamp text-white border-mnp-stamp' : 'border-gray-300'}`}
            >
              {t === 'light' ? 'Светлая' : t === 'dark' ? 'Тёмная' : 'Авто'}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="text-sm font-semibold mb-2">Размер шрифта</p>
        <div className="flex gap-2">
          {VALID_FONT_SIZES.map((s) => (
            <button
              key={s}
              type="button"
              aria-pressed={fontSize === s}
              onClick={() => setFontSizeState(s)}
              data-testid={`fontsize-btn-${s}`}
              className={`px-3 py-1 rounded border text-sm ${fontSize === s ? 'bg-mnp-stamp text-white border-mnp-stamp' : 'border-gray-300'}`}
            >
              {s}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
